import { IGetInfrastructureResponse } from 'shared/common/repositories/infrastructure-caching/v3/get-infrastructure';
import { TApplicationState } from 'shared/mf-infrastructure/types/redux';

export function selectInfrastructureApiResult(state: TApplicationState): IGetInfrastructureResponse | null {
  return state.infrastructure.data;
}
